import dayjs from "dayjs";
import { type OrderLogReadDto } from "@/config/apiClient";
import { type OrderItemLogActionTypeEnum } from "@/config/apiClient.types";

// Find the last log with the given action type after the given date threshold
export const findLastLogAfterDate = (
  orderItemLogs: OrderLogReadDto[],
  actionType: OrderItemLogActionTypeEnum,
  dateThreshold?: string | Date
) => {
  if (!dateThreshold) {
    return undefined;
  }

  return orderItemLogs.findLast(
    (log) =>
      log.actionType === actionType &&
      dayjs(log.createdAt).isAfter(dayjs(dateThreshold))
  );
};
